import { h, render } from "preact";
import RichText from "../helpers/richText";

export default function DimensionRowContent({ products, rowIndex }) {
  return (
    <div className="compare-modal-v2__row-items compare-modal-v2__dimension-row-items">
      {products.map((product) =>
        product.dimensionRows[rowIndex] ? (
          <RichText
            className="compare-modal-v2__row-item compare-modal-v2__rte"
            schema={product.dimensionRows[rowIndex]}
          />
        ) : (
          <div className="compare-modal-v2__row-item">-</div>
        )
      )}
    </div>
  );
}
